// Shared contract for the /send-message backend response.
//
// As of 2026-07-02 the backend returns EXPECTED, per-recipient "not sent" outcomes as
// HTTP 200 { success:false, error, message } (patient opted out, or an invalid /
// undeliverable number) so it doesn't page on-call for normal business outcomes.
// Older backends (and other 4xx/5xx faults) still reject — axios throws — so consumers
// must handle BOTH the 200-success:false shape and the legacy error.response shape.
//
// These outcomes are TERMINAL: resending the same message won't help (the number or the
// patient's "Text OK" must change in Open Dental), so the UI shows a warning and does
// NOT offer a retry.
//
// SMS_DISABLED (2026-10-07): an SMS at a WhatsApp-only office (SMS_OUTBOUND_DISABLED). Also
// terminal — resending can't help; the reply has to go on WhatsApp. The backend code is pinned
// by cypress/node-tests/whatsapp-only-conversations.test.js against conversations-service/inhouse.js.
export const NON_DELIVERY_ERROR_CODES = ['PATIENT_OPTED_OUT', 'UNDELIVERABLE', 'INVALID_NUMBER', 'SMS_DISABLED'];

export function isNonDeliveryCode(code) {
  return NON_DELIVERY_ERROR_CODES.indexOf(code) !== -1;
}

// Normalize either a 200 body (`response.data`) or a rejected axios body
// (`error.response.data`) into a single classification the consumers act on.
// Returns { code, message, isNonDelivery }.
export function classifyNonDelivery(body) {
  const code = body && (body.error || body.errorCode);
  const message = (body && (body.message || body.error)) || 'Failed to send message';
  return { code, message, isNonDelivery: isNonDeliveryCode(code) };
}
